// extracted by mini-css-extract-plugin
module.exports = {"appreciation_day":"Appre_appreciation_day__a6dm7"};